import ApproverExpenseReportsReducer, {
  Actions as ExpensesAllReportsActions,
  ApproverExpenseReportsState,
  initialState as initialExpensesAllReportsState,
} from 'src/app/ApproverExpenseReports/redux/approverExpenseReports.reducer'
import SubmitterExpenseReportsReducer, {
  Actions as ExpensesYourReportsActions,
  initialState as initialExpensesYourReportsState,
  SubmitterExpenseReportsState,
} from 'src/app/SubmitterExpenseReports/redux/submitterExpenseReports.reducer'

export type ExpenseReportsState = {
  expensesAllReports: ApproverExpenseReportsState
  expensesYourReports: SubmitterExpenseReportsState
}

export const initialState: ExpenseReportsState = {
  expensesAllReports: initialExpensesAllReportsState,
  expensesYourReports: initialExpensesYourReportsState,
}

export type Actions = ExpensesAllReportsActions | ExpensesYourReportsActions

const ExpenseReportsReducer = (
  state = initialState,
  action: Actions,
): ExpenseReportsState => ({
  expensesAllReports: ApproverExpenseReportsReducer(
    state.expensesAllReports,
    action as ExpensesAllReportsActions,
  ),
  expensesYourReports: SubmitterExpenseReportsReducer(
    state.expensesYourReports,
    action as ExpensesYourReportsActions,
  ),
})

export default ExpenseReportsReducer
